import { Logo } from '@/components/logo';
import { Scrollbar } from '@/components/scrollbar';
import { SignInButton } from '@/layouts/components/sign-in-button';
import { usePathname } from '@/routes/hooks';
import { paths } from '@/routes/paths';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import { useEffect } from 'react';

import type { NavMainProps } from '../types';

import { Nav, NavUl } from '../components';
import { NavList } from './nav-mobile-list';
import { isUserLogin } from '@/store/reducerUser';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

export type NavMobileProps = NavMainProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ data, open, onClose, slots, sx }: NavMobileProps) {
  const pathname = usePathname();
  const userLoggedIn = useSelector(isUserLogin);

  useEffect(() => {
    if (open) {
      onClose();
    }
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: [
            {
              display: 'flex',
              flexDirection: 'column',
              width: 'var(--layout-nav-mobile-width)',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ],
        },
      }}>
      {slots?.topArea ?? (
        <Box
          sx={{
            pt: 3,
            pb: 2,
            pl: 2.5,
            display: 'flex',
          }}>
          <Logo isSingle={false} isMobile />
        </Box>
      )}

      <Scrollbar fillContent>
        <Nav
          sx={{
            pb: 3,
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
          }}>
          <NavUl>
            {data.map((list) => (
              <NavList key={list.title} data={list} />
            ))}
          </NavUl>
        </Nav>
      </Scrollbar>

      {slots?.bottomArea ?? (
        <Box
          sx={{
            py: 3,
            px: 2.5,
            gap: 1.5,
            display: 'flex',
          }}>
          {!userLoggedIn && <SignInButton fullWidth />}
        </Box>
      )}
    </Drawer>
  );
}
